'use client';
import NotFound from 'features/generic/components/NotFound/NotFound';

export default function NotFoundPage() {
    return <NotFound statusCode={404} />;
}
